import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontFamilies, fontWeights, fontSizes, palette, siteMediumWidth, spaceMin,
}: Theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    maxWidth: siteMediumWidth,
    margin: '2rem auto',
    borderRadius: '0.5rem',
    overflow: 'hidden',
    border: `1px solid ${palette.grey[400]}`,
    [breakpoints.up('md')]: {
      marginBottom: '2rem',
      flexDirection: 'row',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'none',
    [breakpoints.up('md')]: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
    },
    '&:focus-visible': {
      outline: `1px dashed ${palette.primary.dark}`,
      outlineOffset: 2,
    },
  },
  sectionTitle: {
    width: '100%',
    margin: 0,
    color: palette.text.primary,
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.medium,
    fontSize: fontSizes.lg,
    lineHeight: 1.4,
    [breakpoints.up('xl')]: {
      fontSize: fontSizes.xxl,
      lineHeight: 1.32,
    },
  },
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    width: '100%',
    height: '100%',
    padding: spaceMin,
    [breakpoints.up('md')]: {
      padding: '2.25rem',
      overflow: 'visible',
      width: '50%',
    },
  },
  description: {
    margin: '0 0 1rem',
    fontSize: fontSizes.xs,
    lineHeight: 1.4,
    [breakpoints.up('xl')]: {
      fontSize: '1.25rem',
    },
  },
  imgContainer: {
    width: '100%',
    [breakpoints.up('md')]: {
      position: 'relative',
      width: '50%',
      overflow: 'hidden',
    },
    '& img': {
      display: 'block',
      width: '100%',
      height: 'auto',
      objectFit: 'contain',
    },
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'fit-content',
    padding: '0.675rem 1.25rem',
    border: `2px solid ${palette.primary.dark}`,
    borderRadius: '1rem',
    background: palette.common.white,
    color: palette.primary.dark,
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.medium,
    fontSize: fontSizes.sm,
    lineHeight: 1.5,
  },
  newLine: {
    display: 'block',
  },
}));
